module.exports = __webpack_public_path__ + "static/media/1POLICY40.03ca1d57.jpg";